export default "__VITE_ASSET__b6378cca__"